import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useToken } from "@/lib/session";
import { applyTheme } from "@/lib/themes";
import { Store, Sparkles, ArrowLeft, Bell } from "lucide-react";

export default function ShopComingSoon() {
  const token = useToken();
  const navigate = useNavigate();

  useEffect(() => {
    api.get(`/employee/me?token=${token}`).then((r) => applyTheme(r.data.theme || "standard")).catch(() => {});
  }, [token]);

  return (
    <div className="min-h-screen flex flex-col" style={{ background: "var(--bq-bg)", color: "var(--bq-text)" }} data-testid="shop-coming-soon">
      <header className="sticky top-0 z-40 border-b-4 themed-border px-4 md:px-6 py-3 flex items-center justify-between" style={{ background: "var(--bq-card-bg)" }}>
        <div className="flex items-center gap-2 font-black uppercase text-lg"><Store size={22} /> Merch Store</div>
        <button data-testid="coming-soon-back" onClick={() => navigate("/play")} className="inline-flex items-center gap-1 px-3 py-2 border-2 themed-border font-black uppercase text-xs" style={{ background: "var(--bq-card-bg)" }}>
          <ArrowLeft size={14} /> Back to Hub
        </button>
      </header>

      <main className="flex-1 flex items-center justify-center px-4 py-16">
        <div className="brutal-card p-8 md:p-12 max-w-lg w-full text-center" style={{ background: "var(--bq-card-bg)" }}>
          <div className="w-20 h-20 mx-auto mb-6 flex items-center justify-center border-4 themed-border themed-shadow-accent" style={{ background: "var(--bq-accent)" }}>
            <Sparkles size={40} />
          </div>
          <h1 className="text-4xl md:text-5xl font-black uppercase leading-none mb-3">Coming Soon</h1>
          <p className="text-base mb-2 font-bold">The TekWissen Merch Store is on its way! 🎉</p>
          <p className="text-sm mb-8" style={{ color: "var(--bq-muted)" }}>
            Keep earning points by playing daily games — soon you'll be able to redeem them for exclusive company swag, apparel and accessories.
          </p>
          <button data-testid="coming-soon-play" onClick={() => navigate("/play")} className="brutal-btn inline-flex items-center gap-2">
            <Bell size={16} /> Keep Playing to Earn Points
          </button>
        </div>
      </main>
    </div>
  );
}
